import type { CheckoutSessionsResponse } from '../../services/commonCheckout/types/CheckoutSessionsResponse';

export const removeHcpToken = (
  json: CheckoutSessionsResponse,
) => {
  const { hcpToken: _, ...rest } = json;
  return rest;
};
